import { Link } from "react-router-dom";

export const Wordmark = ({ size = "md", testId = "wordmark" }) => {
  const sizes = {
    sm: { name: "text-lg", est: "text-[7px]", line: "w-5" },
    md: { name: "text-2xl sm:text-3xl", est: "text-[8px]", line: "w-7" },
    lg: { name: "text-4xl", est: "text-[10px]", line: "w-10" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <Link
      to="/"
      data-testid={testId}
      className="inline-flex flex-col items-center leading-none select-none group"
    >
      <span
        className={`font-serif font-medium tracking-[0.3em] text-aveden-white ${s.name} transition-opacity duration-500 group-hover:opacity-80`}
      >
        AVEDEN
      </span>
      <span className="flex items-center gap-2.5 mt-2.5">
        <span className={`h-px ${s.line} bg-white/35`} />
        <span
          className={`font-sans font-light tracking-[0.4em] text-aveden-white/75 ${s.est}`}
        >
          EST. 2025
        </span>
        <span className={`h-px ${s.line} bg-white/35`} />
      </span>
    </Link>
  );
};

export default Wordmark;
